export var Ondigoform = {};
Ondigoform.Validator = {};
Ondigoform.MultiStep = {};

Ondigoform = {
    Validation: {
        optional: function (element) {
            'use strict';
            return (this.checkable(element) && $(element).closest('div').attr('class').indexOf('validateNotEmpty') === -1)
                || ($(element).attr('required') && ($(element).attr('required') !== 'required'));
        },
        checkable: function (element) {
            'use strict';
            return (/radio|checkbox/i).test(element.type);
        },
        validateFile: function (element) {
            return $(element).parents('.row').find('.fileUploadLabel').val().length > 0;
        },
        validateNotEmpty: function (element) {
            'use strict';
            var $element = $(element),
                value = $element.val(),
                placeholderValue = $element.attr('placeholder');

            if (element.nodeName.toLowerCase() === "select") {
                return value && value.length > 0;
            }

            // for non placeholder capable browsers
            if (value == placeholderValue) {
                return false;
            }

            if (this.checkable(element)) {
                switch (element.nodeName.toLowerCase()) {
                    case "select":
                        return $("option:selected", element).length;
                    case "input":
                        return $(element).closest('.ondigoform').find("[name='" + element.name + "']:checked").length;
                }
                return value.length > 0;
            }
            return $.trim(value).length > 0;
        },
        validateNumber: function (element) {
            'use strict';
            /^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test($(element).val());
        },
        validateDate: function (element) {
            'use strict';
            return !/Invalid|NaN/.test(new Date($(element).val()).toString());
        },
        validateDigitsOnly: function (element) {
            'use strict';
            return (/^\d+$/.test($(element).val()));
        },
        validateLettersOnly: function (element) {
            'use strict';
            return (/^[a-zA-Z ]*$/.test($(element).val()));
        },
        validateEmail: function (element) {
            'use strict';
            // validate only if the field is required and not empty
            if ($(element).hasClass('validateNotEmpty') || (!$(element).hasClass('validateNotEmpty') && $(element).val() !== '')) {
                return (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test($(element).val()));
            } else {
                return true;
            }
        },
        validateMaximumInput: function (element) {
            'use strict';
            // validate only if the field is required and not empty
            //maximum amount is in data-maximum-value
            var maxValue = parseFloat($(element).data('maximum-value')),
                choosenValue = parseFloat($(element).val());

            return choosenValue <= maxValue;
        }
    },
    Validator: {
        init: function (form) {
            'use strict';

            $(form).attr('novalidate', 'novalidate');

            $('input, textarea, select', form).not('input:submit, input:button').on('focusout', function (e) {
                Ondigoform.Validator.validateElement(e.currentTarget);
            });

            $('input, textarea, select', form).not('input:submit, input:button').on('keyup', function (e) {
                if (e.keyCode !== 9) { // Tab
                    if ($(e.target).parents('.invalid').length) {
                        Ondigoform.Validator.validateElement(e.currentTarget);
                    }
                }
            });

            $('input:radio, input:checkbox').on('change', function (e) {
                Ondigoform.Validator.validateElement(e.currentTarget);
            });
        },

        invalidCallback: function (element, validationClass) {
            'use strict';

            var $errorWrapper,
                $errorMessage,
                $row;

            validationClass = validationClass.replace('validate', '').toLowerCase();

            if (Ondigoform.Validation.checkable(element)) {
                element = $(element).closest('div');
            }

            $errorWrapper = $(element).is('select') ? $(element).closest('.selectOverflow').next('.errorWrapper') : $(element).next('.errorWrapper');

            if ($(element).attr('type') == 'file') {
                var rowToChange = $(document).find('#row-' + $(element).attr('id'));
                rowToChange.removeClass('valid firstTry').addClass('invalid');
            }

            if ($errorWrapper.length === 0) {
                $errorWrapper = $('<div class="errorWrapper"></div>');
            } else {
                $errorWrapper = $errorWrapper.first();
            }

            if ($errorWrapper.find('.' + validationClass).length === 0) {
                $errorWrapper.find('.error').not('.' + validationClass).remove();
                $errorMessage = $('<div class="error ' + validationClass + '"></div>').text($(element).data('error-' + validationClass));
                $errorWrapper.append($errorMessage);
                $errorMessage.show();
                if ($(element).is('select')) {
                    $(element).closest('.selectOverflow').after($errorWrapper);
                } else if ($(element).hasClass('upload')) {
                    if (!$(element).closest('.button').next().hasClass('errorWrapper')) {
                        $(element).closest('.button').after($errorWrapper);
                    }
                } else {
                    $(element).after($errorWrapper);
                }
            }

            $row = $errorWrapper.closest('.row');
            $row.removeClass('valid firstTry').addClass('invalid');
        },

        validCallback: function (element, validationClass) {
            'use strict';

            var $errorWrapper,
                $errorMessage,
                $row;

            validationClass = validationClass.replace('validate', '').toLowerCase();

            if (Ondigoform.Validation.checkable(element)) {
                element = $(element).closest('div');
            }

            $errorWrapper = $(element).is('select') ? $(element).closest('.selectOverflow').next('.errorWrapper') : $(element).next('.errorWrapper');
            $row = $errorWrapper.closest('.row');

            if ($(element).attr('type') == 'file') {
                var rowToChange = $(document).find('#row-' + $(element).attr('id'));
                rowToChange.removeClass('invalid').addClass('valid');
                return;
            }

            if ($errorWrapper.length === 0) {
                $(element).closest('.row').addClass('valid firstTry');
                return;
            }

            $errorMessage = $errorWrapper.find('.' + validationClass);
            if ($errorMessage.length === 0) {
                $(element).closest('.row').addClass('valid firstTry');
                return;
            }

            setTimeout(function () {
                $errorMessage.remove();
                if ($errorWrapper.find('.error').length === 0) {
                    $errorWrapper.remove();
                }
            }, 400);

            $row.removeClass('invalid').addClass('valid');
        },

        validateForm: function (form) {
            'use strict';

            var valid = true,
                that = this;

            $('.jsFormStep', form).each(function (i, fieldSet) {
                valid = that.validateFieldSet(fieldSet) === false ? false : valid;
            });

            return valid;
        },

        validateFieldSet: function (fieldSet) {
            'use strict';

            var valid = true,
                that = this;

            $('input, textarea, select', fieldSet).not('input:submit, input:button').each(function (i, element) {
                valid = that.validateElement(element) === false ? false : valid;
            });

            return valid;
        },

        validateElement: function (element) {
            'use strict';

            var classNames,
                validators;

            if (Ondigoform.Validation.checkable(element)) {
                classNames = $(element).closest('div:not(".checkItem")').attr('class');
            } else {
                classNames = $(element).attr('class');
            }

            if (!classNames) {
                return true;
            }

            validators = classNames.split(' ').filter(function (className) {
                return className.indexOf('validate') === 0;
            });

            return validators.every(function (validationFn) {
                if (!Ondigoform.Validation.hasOwnProperty(validationFn)) {
                    // no submit should be prevented by errors from validation-Methods that don't exist
                    return true;
                }

                if (Ondigoform.Validation.optional(element) || Ondigoform.Validation[validationFn](element)) {
                    Ondigoform.Validator.validCallback(element, validationFn);
                    return true;
                }

                Ondigoform.Validator.invalidCallback(element, validationFn);
                return false;
            });
        },

        formHasInvalidElements: function (form) {
            'use strict';

            return $('.error', form).length > 0;
        },

        focusFirstInvalidElement: function (form) {
            'use strict';

            var $wrapper,
                $invalidElement,
                $formStep;

            $wrapper = $('input, textarea, select', form).not('input:submit, input:button').closest('div');
            if ($wrapper && $wrapper.find('.error').length > 0) {
                $invalidElement = $wrapper.find('.error').first();
                $formStep = $invalidElement.closest('.jsFormStep');
                if (!$formStep.is(':visible')) {
                    $('.jsFormStep', form).each(function (i, fieldSet) {
                        $(fieldSet).hide();
                    });
                    $formStep.show();
                }
                $('html, body').animate({scrollTop: $invalidElement.offset().top - 50}, 800, function () {
                    $invalidElement.focus();
                });
            }
        }
    },
    MultiStep: {
        init: function (form) {
            'use strict';

            var $steps = $('.jsFormStep', form),
                $select = $('select'),
                $this,
                $parentRow,
                $textInputs = $('input:not([type="checkbox"]):not([type="submit"]):not([type="hidden"]), textarea', form);

            if (!$steps.length) {
                return;
            }

            $steps.each(function (i, fieldSet) {
                $(fieldSet).hide();
            });
            $steps.first().show();

            $textInputs.on('change keydown keyup', function () {
                $this = $(this);
                $parentRow = $this.parents('.row');
                window.setTimeout(function () {
                    if ($this.val() !== '') {
                        $parentRow.addClass('hasValue');
                    }
                    else {
                        $parentRow.removeClass('hasValue');
                    }
                });
            });

            $textInputs.on('focus', function () {
                $(this).parents('.row').addClass('hasFocus');
            });

            $textInputs.on('blur', function () {
                $(this).parents('.row').removeClass('hasFocus');
            });

            $textInputs.each(function(i, form) {
                $this = $(this);
                $parentRow = $this.parents('.row');
                if ($this.val() !== '') {
                    $parentRow.addClass('hasValue');
                }
                else {
                    $parentRow.removeClass('hasValue');
                }
                $textInputs.parents('.row').find('label').addClass('activatedCssAnimation');
            });

            $select.on('change', function (e) {
                $this = $(this);
                $parentRow = $this.parents('.row');
                $(this).trigger('blur');
                $(this).parents('.row').next().find('input').focus();
                $this.parents('.row').find('label').addClass('activatedCssAnimation');
                window.setTimeout(function () {
                    if ($this.val() !== '') {
                        $parentRow.addClass('hasValue');
                    }
                    else {
                        $parentRow.removeClass('hasValue');
                    }
                });
            });

            $(form).on('submit', this.submitHandler);
            $('input, textarea, select', form).not('input:submit, input:button').on('focus', function (e) {
                var placeholder = $(e.currentTarget).attr('placeholder'),
                    placeHolderDetail = $(e.currentTarget).data('placeholder-detail');

                if (placeHolderDetail) {
                    $(e.currentTarget).attr('placeholder', placeHolderDetail);
                }

                $(e.currentTarget).one('focusout', function (e) {
                    $(e.currentTarget).attr('placeholder', placeholder);
                });
            });

            $('.jsButtonNext', form).on('mouseup', this.buttonNextClickHandler);
            $('.jsButtonBack', form).on('mouseup', this.buttonBackClickHandler);

            if (Ondigoform.Validator.formHasInvalidElements(form)) {
                Ondigoform.Validator.focusFirstInvalidElement(form);
            }

            $select.on('focus', function (e) {
                $(e.currentTarget).closest('.selectOverflow').addClass('hasFocus');
            }).on('focusout', function (e) {
                $(e.currentTarget).closest('.selectOverflow').removeClass('hasFocus');
            });

            //reset if user enters the page a second time (firefox)
            $('.fileUploadLabel').val('');

            $('.upload').on('change', function (e) {
                var $row = $(e.currentTarget).closest('.row'),
                    filename = $(e.currentTarget).val().replace(/C:\\fakepath\\/i, ''),
                    $clearInput = $('.clearInput', $row);
                $('.fileUploadLabel', $row).val(filename);
                $clearInput.addClass('visible');
                $clearInput.on('click', function (e) {
                    $('.fileUploadLabel', $row).val('');
                    $('.upload', $row).val('');
                    $clearInput.removeClass('visible');
                });
            });
        },

        buttonNextClickHandler: function (e) {
            'use strict';

            e.preventDefault();

            var $button = $(e.currentTarget),
                $current = $button.closest('.jsFormStep'),
                $next;

            if (Ondigoform.Validator.validateFieldSet($current)) {
                $current.hide();
                $next = $current.next('.jsFormStep');
                $next.show();
            } else {
                Ondigoform.Validator.focusFirstInvalidElement($current);
            }
            $('html, body').animate({scrollTop: $(e.target).parents('.ondigoform').offset().top - 20}, 400);
        },

        buttonBackClickHandler: function (e) {
            'use strict';

            e.preventDefault();

            var $button = $(e.currentTarget),
                $current = $button.closest('.jsFormStep'),
                $next = $current.prev('.jsFormStep');

            $current.hide();
            $next.show();
            $('html, body').animate({scrollTop: $(e.target).parents('.ondigoform').offset().top - 20}, 400);
        },

        submitHandler: function (e) {
            'use strict';

            var $form = $(e.currentTarget).closest('.ondigoform form');
            if (!Ondigoform.Validator.validateForm($form)) {
                e.preventDefault();
                e.stopPropagation();
                Ondigoform.Validator.focusFirstInvalidElement($form);
            }
        }
    }
};

$(document).ready(function () {
    'use strict';

    var $forms = $('.ondigoform form');
    $forms.each(function (i, form) {
        Ondigoform.Validator.init(form);
        Ondigoform.MultiStep.init(form);
    });
});